import React from "react";

// screen sizes.
const ButtonGroup = props => (
  <div className="cb-c-button-group">{props.children}</div>
);

export default ButtonGroup;
